import React from "react";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import { MuiDropDown } from "./../components/basicComponent/MuiDropDown";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiDatePicker from "./../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import Header from "./../sharedScreens/Header";
import { FormGroup, FormLabel } from "@mui/material";

const PassengerProfile = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Passenger Profile</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4 mt-3">
                        <MuiSearchSelect
                          placeholder={" Corporate Name"}
                          label="Corporate Name "
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div className="row mt-3">
                        <FormLabel
                          sx={{ color: " #38aecc", fontWeight: "bold" }}
                        >
                          User Details
                          <span style={{ color: "red" }}>*</span>
                        </FormLabel>
                        <FormGroup
                          sx={{
                            border: "1px solid #ccc",
                            padding: "8px",
                            borderRadius: "4px",
                            width: "100%",
                          }}
                        >
                          <div className="row">
                            <div className="col-md-4 mt-3">
                              <MuiInput label={"Email"} placeholder="Email" />
                            </div>
                            <div className="col-md-4 mt-3">
                              <MuiSearchSelect
                                placeholder={"Passenger Type"}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>
                            <div className="col-md-4 mt-3">
                              <MuiSearchSelect
                                placeholder={"Title"}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>
                            <div className="col-md-3 my-3">
                              <MuiInput
                                label={"First Name"}
                                placeholder="First Name"
                              />
                            </div>
                            <div className="col-md-3 my-3">
                              <MuiInput
                                label={"Last Name"}
                                placeholder="Last Name"
                              />
                            </div>
                            <div className="col-md-3 my-3">
                              <MuiInput label={"Mobile No"} />
                            </div>

                            <div className="col-md-3 my-3">
                              <MuiDatePicker
                                label="Date of Birth"
                                value={null}
                                onChange={function (date: string): void {
                                  throw new Error("Function not implemented.");
                                }}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </div>

                      <div className="row mt-3">
                      <FormLabel
                          sx={{ color: " #38aecc", fontWeight: "bold" }}
                        >
                         Passport Details   
                          <span style={{ color: "red" }}>*</span>
                        </FormLabel>
                        <FormGroup
                          sx={{
                            border: "1px solid #ccc",
                            padding: "8px",
                            borderRadius: "4px",
                            width: "100%",
                          }}
                        >
                            <div className="row">
                        <div className="col-md-4 mt-3">
                          <MuiInput label={"Passport No"} />
                        </div>

                        <div className="col-md-4 mt-3">
                          <MuiInput
                            label={"Issued Country"}
                            placeholder="Issued Country"
                          />
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiDatePicker
                            label="Passport Expiry Date"
                            value={null}
                            onChange={function (date: string): void {
                              throw new Error("Function not implemented.");
                            }}
                          />
                        </div>

                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Nationality"}
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                        </div>
                        </FormGroup>
                      </div>

                      <div className="row mt-3">

                   
                      <FormLabel
                          sx={{ color: " #38aecc", fontWeight: "bold" }}
                        >
                          Frequent Flyer
                          <span style={{ color: "red" }}>*</span>
                          </FormLabel>
                          <FormGroup
                          sx={{
                            border: "1px solid #ccc",
                            padding: "8px",
                            borderRadius: "4px",
                            width: "100%",
                          }}
                        >
                            <div className="row">
                      <div className="col-md-4 my-3">
                        <MuiSearchSelect
                          placeholder={"Airline"}
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div className="col-md-4 my-3">
                        <MuiInput label={"FFN Number"} />
                      </div>
                      </div>
                      </FormGroup>

                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton className="clear-btn " label="Clear" />
                          <MuiButton
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                            label={"submit"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PassengerProfile;
